export enum Basketball3x3FreeThrowsAwardedAttribute {
  One = 708,
  Two = 709,
}
